import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  Modal,
  Typography,
  Card,
  Grid,
  CardContent,
  Select,
  Tooltip,
  IconButton ,
  MenuItem,
  InputLabel,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Alert, 
  AlertTitle, 
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { GetMap,getStates,GetCounty } from "../../utils/GetAdmin";
import TableAbstraction  from "../../componentUtils/TableAbstraction";
import {checkForRole} from "../../utils/GetAuth";
import LockIcon from '@mui/icons-material/Lock';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import Clear from "@mui/icons-material/Clear";
import { saveMap } from "../../utils/PostAdmin";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center"
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalGrid: {
      marginTop: theme.spacing(2),
    },
    modalTitle:{
      color: theme.palette.primary.main,
    },
    modalCard: {
    },
    modalText: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      width: 500,
      maxWidth: 500
    },
    modalInput: {
      paddingLeft: "20px", 
      paddingRight: "20px", 
      width:"350px"
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: `1px solid`,
        borderColor: theme.palette.border.main, 
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2),
    },
  })
);

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
  };
}
export default function AdminMaps() {
    const classes = useStyles();
    const [mapdetails, SetMapdetails] = useState<any[]>([]);
    const [counties, setCounties] = useState<any>();
    const [clientId,] = useLocalStorage("SETTINGS.clientId", "100");
    const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
    const enabled = checkForRole(clientId,salesOrg,'vp_admin');
    const [doneLoading, setDoneLoading] = React.useState<boolean>();
    const [muiTable, setMuiTable] = React.useState<any>({rpp:25});
    const [useCompact] = useLocalStorage("SETTINGS.compact", true);
    const [openEditWindow, setOpenEditWindow] = React.useState(false);
    const [confirmDelete, setConfirmDelete] = React.useState<boolean>(false);
    const [modalStyle] = React.useState(getModalStyle);
    const [states, setStates] = React.useState<any>();
    const [editedRowState, setEditedRowState] = React.useState<string>("");
    const [editedRowCounty, setEditedRowCounty] = React.useState<string>("");
    const [editedRow, setEditedRow] = React.useState<any|undefined>(undefined);


    const handleModalClose = () => {
      setOpenEditWindow(false);
      setEditedRow(undefined);
      setEditedRowState('');
      setEditedRowCounty('');
    }
    const handleDelete = () => {
      let oldMap = (editedRow) ? {
        state: editedRow.stateFips, 
        county:editedRow.countyFips
      } : undefined;
      saveMap(salesOrg,oldMap,undefined).then((ret: any) => {
        if(ret && ret.data){
          SetMapdetails(ret.data.mdMap);
        }
      }); 
      setEditedRow(undefined);
    }

    const stateChange = (stateFips: any) => {
      setEditedRowCounty('*');
      GetCounty(stateFips,salesOrg).then((v) => {
        if(v) setCounties(v.conties);
      })
    }
    
    const setCurrent = (tableRow:any) => {
        setEditedRow(tableRow);
        setEditedRowState(tableRow.stateFips);
        GetCounty(tableRow.stateFips,salesOrg).then((v) => {
          if(v) setCounties(v.conties);
        })
       
        setEditedRowCounty(tableRow.countyFips);
    }
    const handleEdit = (tableRow:any) => {
        setCurrent(tableRow);
        setOpenEditWindow(true);
      }

      const handleModalSave = () => {
        let oldMap = (editedRow) ? {
          state: editedRow.stateFips, 
          county:editedRow.countyFips
        } : undefined;
        let newMap = {state:editedRowState,county:editedRowCounty};
    
        saveMap(salesOrg,oldMap,newMap).then((ret: { data: any; }) => {
          if(ret && ret.data){
            SetMapdetails(ret.data.mdMap);
          }
        }); 
        handleModalClose();
      } 

      const modalBody = (
        <div style={modalStyle} className={classes.paper} >
        <Typography variant="h4" className={classes.modalTitle} paragraph>Map Details</Typography>
        <Grid container spacing={2} className={classes.modalGrid}>
          <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
            <Card className={classes.modalCard}>
              <CardContent>
              <Grid container spacing={1} className={classes.modalGrid}>
                <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
                <InputLabel >State</InputLabel>
                <Select label="State" required placeholder='State' value={editedRowState}
                inputProps={{name: 'State',}}
                className={classes.modalInput}
                onChange={(e) => { 
                  stateChange(e.target.value);
                  setEditedRowState((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "*"); 
                    }}>
                {(states)?(Object.entries(states).map((so: any, i: number) => (
                  <MenuItem key={so[1].state_fips} value={so[1].state_fips}>
                    { so[1].state_name}
                  </MenuItem>
                  ))):(<></>)}
            </Select>
                </Grid>
               </Grid>
               <Grid container spacing={1} className={classes.modalGrid}>
                <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
                <InputLabel >County</InputLabel>
                <Select label="County" required placeholder='County' value={editedRowCounty}
                inputProps={{name: 'County',}}
                className={classes.modalInput}
                onChange={(e) => { 
                  setEditedRowCounty((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "*"); 
                    }}
                >
                <MenuItem key='*' value='*'>{ "All"}</MenuItem>
                {(counties)?(Object.entries(counties).map((so: any, i: number) => (
                  <MenuItem key={so[1].county_fips} value={so[1].county_fips}>
                    { so[1].county_name}
                  </MenuItem>
                  ))):(<></>)}
            </Select>
                </Grid>
               </Grid>
                </CardContent>
              </Card>
              <div style={{ paddingRight: "5px", textAlign:"right"}}>
                    <React.Fragment>
                        <Tooltip title={"Save"}>
                            <IconButton onClick={handleModalSave}>
                                <SaveIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title={"Cancel"}>
                            <IconButton onClick={handleModalClose}>
                                <Clear />
                            </IconButton>
                        </Tooltip>
                    </React.Fragment>
                  </div>
            </Grid>
          </Grid>
        </div>
      );
      useEffect(() => {
        if (doneLoading) return;
       let stateslist:any
       let mapdetails:any;
        Promise.all(
          [
            (
              GetMap(salesOrg).then((v) => {
                if(v) mapdetails = v
              })
            ),
            (
              getStates(salesOrg).then((v) => {
                if(v) stateslist = v.states
              })
            )

          ]
        )
        .then(()=>{
          setDoneLoading(true);
          setStates(stateslist);
          SetMapdetails(mapdetails);
        })
        .catch(()=>setDoneLoading(true))
      }, [mapdetails,counties,doneLoading,salesOrg]);

    return (
       <div>
           {doneLoading && enabled ? (
          <TableAbstraction
            settingsKey="ADM_MAP"
            options={{
              draggableColumns: {
                enabled: true,
              },
              rowsPerPageOptions: [25, 50, 100],
              serverSide: false,
              selectableRows: "none",
              rowsPerPage: muiTable.rpp,
              onChangeRowsPerPage: (numberOfRows) => {
                muiTable.rpp = numberOfRows;
                setMuiTable(muiTable);
              },
              customToolbar: () => {
                return (
                  <Tooltip title={`Add Map`}>
                    <IconButton  onClick={() => {
                      handleModalClose();
                      setOpenEditWindow(true);
                    }}>
                      <AddIcon />
                    </IconButton>
                  </Tooltip>
                );
              },
            }}
            title="Map Details"
            columns={[
              {
                name: "stateFips",
                options: {
                  display: false,
                }
              }, 
              {
                name: "countyFips",
                options: {
                  display: false,
                }
              }, 
              {
                label: "State",
                name: "stateName",
                options: {
                  filter: true,
                },
              },
              {
                label: "County",
                name: "countyName",
                options: {
                  filter: true,
                  customBodyRender: (value: any) =>
                   value == null ? 'All' :`${value}`,
                   
                },
              },
              {
                label: " ",
                name: "active",
                options: {
                  filter: false,
                  setCellProps: () => ({ align: 'right' }),
                  renderCell: (params) => {
                    if(!!useCompact)
                      return (
                          <React.Fragment>
                            <Tooltip title={"Edit"}>
                              <EditIcon 
                                fontSize="small"  
                                onClick={() => {handleEdit(params.row)}}/>
                            </Tooltip>
                            <Tooltip title={"Delete"}>
                              <DeleteIcon
                                fontSize="small" 
                                onClick={() => {setCurrent(params.row); setConfirmDelete(true);}} 
                              />
                            </Tooltip>
                          </React.Fragment>
                        );
                      else
                        return (
                            <React.Fragment>
                              <Tooltip title={"Edit"}>
                                <IconButton onClick={() => {handleEdit(params.row)}}>
                                  <EditIcon />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title={"Delete"}>
                                <IconButton onClick={() => {setCurrent(params.row); setConfirmDelete(true);}}>
                                  <DeleteIcon />
                                </IconButton>
                              </Tooltip>
                            </React.Fragment>
                          );
                  },
                },
              },
            ]}
            data={mapdetails}
          />
        ) : ( enabled ? (
          <div className={classes.centerDiv}>
            <CircularProgress color="primary" />
          </div>) : (
          <Alert severity="error">
            <AlertTitle><LockIcon/> Access Error</AlertTitle>   
            You do not currently have access to <strong>Admin</strong> activities for the <strong>{salesOrg}</strong> bottler. 
          </Alert>
          )
        )}
        <Modal
        open={openEditWindow}
        onClose={handleModalClose}
      >
        {modalBody}
      </Modal>
      <Dialog
          open={confirmDelete}
          onClose={()=>setConfirmDelete(false)}
        >
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you wish to delete?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={()=>{handleDelete(); setConfirmDelete(false);}} color="primary">
              Yes
            </Button>
            <Button onClick={()=>{setEditedRow(undefined); setConfirmDelete(false);}} color="primary" autoFocus>
              No
            </Button>
          </DialogActions>
        </Dialog>
       </div>
      );
}